
$( document ).ready(function() {
    if ($('.ebkph-view').length === 1) {
        project_ebkph.init();
    }
});

var project_ebkph = {
    isActive: false,
    container: null,
    calculationId: null,

    init: function() {
        this.isActive = true;
        this.container = $('.main-page .ebkph-tree');
        this.table = this.container.find('table');
        this.calculationId = this.container.attr('data-calculationId');

        this.container.find('.reload-ebkph').click(function() {
            project_ebkph.loadProject();
        });
        if ($('#object [data-posid]').length === 0) {
            $(project).on('projectloaded', function () {
                project_ebkph.loadProject();
            });
        } else {
            project_ebkph.loadProject();
        }

        $('[data-showPrices]').click(function() {
            var icon = $(this).find('i');
            if (project.container.is('.show-prices')) {
                project.container.removeClass('show-prices');
                icon.addClass('bi-eye').removeClass('bi-eye-slash');
            } else {
                project.container.addClass('show-prices');
                icon.removeClass('bi-eye').addClass('bi-eye-slash');

                var bkpTotal = 0;
                $.each(project.container.find('tr.level-1 [data-brtprice]'), function() {
                    bkpTotal += parseInt($(this).attr('data-brtprice') || 0);
                });
                project.container.find('tr.footer .project-total').html(bkpTotal.toLocaleString('de-CH', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }));
            }
        });
        $('[data-recalculate-ebkph]').click(project_ebkph.recalculateAll);
        $(project).on('positionreloaded', function(ev, options) {
            debugger;
            project.container.find('[data-type="priceposition"].leaf').draggable({
                helper: function(el) {
                    return '<div class="bg-light p-1">Position auf die rechte Seite in die BIM-Position ziehen.</div>';
                },
                appendTo: $('body')
            });
            project_ebkph.registerDragndrop();
        });
        $(project).on('positionopened', function(ev, parent) {
            project.container.find('[data-type="priceposition"].leaf').draggable({
                helper: function(el) {
                    return '<div class="bg-light p-1">Position auf die rechte Seite in die BIM-Position ziehen.</div>';
                },
                appendTo: $('body')
            });
            project_ebkph.registerDragndrop();
        });
        $(project).on('position-saved', function(ev, data) {
            if (data.data.fields['netprice-leaf-plain-' + data.positionLeafId]) {
                var price = data.data.fields['netprice-leaf-plain-' + data.positionLeafId].trim();
                if (data.sourceFieldEl) {
                    project_ebkph.changePositionPrice(data.data.ebkph, data.positionId, data.positionLeafId, data.data.calculationId, price);
                }
            }
        });
    },

    changePositionPrice: function(ebkphNumber, positionId, positionLeafId, calculationId, price) {
        connection.getJson("/ProjectEbkph/SavePositionPrice", {
            type: 'POST',
            data: {
                number: ebkphNumber,
                calculationId: calculationId,
                positionLeafId: positionLeafId,
                positionId: positionId,
                price: price,
            },
            onComplete: function () {
                // me.endProcess();
            }
        });
    },

    registerDragndrop: function() {
        project_ebkph.container.find(".drop-target").droppable({
            cancel: '',
            accept: "[data-type=\"priceposition\"]",
            over: function(event, ui) {
                var me = $(this);
                me.addClass('drag-over');
                setTimeout(function() {
                    if (me.is('drag-over')) {
                        project_ebkph.openSubPositions(null, me);
                    }
                }, 600);
            },
            out: function(event, ui) {
                $(this).removeClass('drag-over');
            },
            drop: function(event, ui) {
                var source = $(ui.draggable[0]);
                var droppable = $(this);
                droppable.removeClass('drag-over');
                connection.getJson('/ProjectEbkph/CopyEbkphPosition', {
                    data: {
                        id: source.attr('data-id'),
                        number: droppable.attr("data-rootid"),
                    },
                    onSuccess: function(data) {
                        var resultEl = $(data.rowEl);
                        droppable.after(resultEl);
                        onContentReady(resultEl);
                        project_ebkph.registerActions(resultEl);
                        project_ebkph.changePositionPrice(resultEl.attr('data-parentnr'), resultEl.attr('data-positionid'), resultEl.attr('data-leafid'), project.calculationId, resultEl.find('[data-netprice]').attr('data-netprice'));
                        // messaging.showGlobalMessage('success', null, 'Die Position wurde zugewiesen.');
                    },
                    onError: function() {
                        messaging.showGlobalMessage('error', null, 'Fehler beim zuweisen der Position.');
                    }
                });
            }
        });
    },

    registerActions: function(container) {
        if (container.is('[data-posslidein]')) {
            container.click(function() {
                slidein.openUrl($(this).attr('data-posslidein'), function (element) {
                    project.initPositionDetails(element);
                });
            });
        }
        container.find('[data-posslidein]').click(function() {
            var me = $(this);
            $('.slidein-active').removeClass('slidein-active');
            $('.slidein-tree-active').removeClass('slidein-tree-active');
            me.addClass('slidein-active');
            //
            slidein.openUrl($(this).attr('data-posslidein'), function (element) {
                project.initPositionDetails(element);
            });
        });
        container.find('[data-unlink]').click(function(e) {
            e.preventDefault();
            var me = $(this);
            var rowEl = me.closest('tr');
            messaging.askYesNo('Position löschen', 'Willst du die Position wirklich entfernt?', function() {
                me.startProcess();
                connection.getJson('/ProjectEbkph/DeleteEbkphPosition', {
                    data: {
                        id: me.attr('data-unlink'),
                        calculationId: me.closest('[data-calculationid]').attr('data-calculationid'),
                    },
                    onSuccess: function(data) {
                        rowEl.remove();
                        messaging.showGlobalMessage('success', null, 'Die Position wurde entfernt.');
                    },
                    onError: function() {
                        me.endProcess();
                        messaging.showGlobalMessage('error', null, 'Fehler beim entfernen der Position.');
                    }
                });
            });
        });
    },

    recalculateAll: function() {
        project_ebkph.container.applyLoader(true, "Investitionsprognose wird neu gerechnet");
        var me = $(this);
        connection.getJson(me.attr('data-recalculate-ebkph'), {
            timeout: 60000,
            onSuccess: function(data) {
                project_ebkph.loadProject();
            },
            onError: function() {
                project_ebkph.container.hideLoader();
            }
        });
    },

    loadProject: function() {
        if (!project_ebkph.container) {
            return;
        }
        project_ebkph.container.applyLoader(true, "Lade Projektdaten ...");
        project_ebkph.table.html('');

        connection.getHtmlPart('/ProjectEbkph/ShowTree', {
            timeout: 50000,
            data: {
                calculationId: project.calculationId,
            },
            onSuccess: function (data) {
                project_ebkph.table.html(data);
                onContentReady(project_ebkph.table);
                project_ebkph.table.find('.toggle-handler')
                    .off('click').on('click', project_ebkph.openSubPositions);
            },
            onComplete: function() {
                project_ebkph.container.hideLoader();
            }
        });
    },

    openSubPositions(ev, rowEl) {
        var me = rowEl || $(this).closest('tr');
        var rootId = me.attr('data-rootId');
        var calculationId = project.calculationId;
        var subBody = project_ebkph.table.find('.sub-' + rootId);
        //
        if (me.is('.opened')) {
            subBody.removeClass('show').html('');
            me.removeClass('opened');
        } else {
            project_ebkph.table.find('tbody.show').removeClass('show').html('');
            project_ebkph.table.find('tr.opened').removeClass('opened');
            //
            connection.getHtmlPart('/ProjectEbkph/ShowTree', {
                timeout: 50000,
                data: {
                    rootId: rootId,
                    calculationId: calculationId,
                },
                onBeforeSend: function() {
                    me.addClass('progressing');
                },
                onComplete: function() {
                    me.removeClass('progressing');
                },
                onSuccess: function (data) {
                    me.addClass('opened');
                    subBody.addClass('show').html(data);
                    project_ebkph.registerDragndrop();
                    project_ebkph.registerActions(subBody);
                    onContentReady(subBody);
                }
            });
        }
    }

};
window.project_ebkph = project_ebkph;
